import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// project imports
import useAuth from 'hooks/useAuth';

import { useSelector } from 'react-redux';

// ==============================|| AUTH GUARD ||============================== //

/**
 * Authentication guard for routes
 * @param {PropTypes.node} children children element/node
 */
const AuthGuard = ({ children }) => {
  const { isLoggedIn, tokens } = useAuth();
  const navigate = useNavigate();

  // const stateFromRedux = useSelector((state) => state.account); // accountReducer に対応する state を取得
  // console.log('Redux state in AuthGuard:', stateFromRedux);

  // console.log('isLoggedIn:', isLoggedIn);
  // console.log('tokens:', tokens);

  useEffect(() => {
    if (!isLoggedIn) {
      // console.log('AuthGuard replace前');
      window.location.replace(`${process.env.REACT_APP_LOGOUT_CALLBACK}?status=401&referer=${window.location.origin}`);
    }
  }, [isLoggedIn, navigate]);

  return children;
};

AuthGuard.propTypes = {
  children: PropTypes.node
};

export default AuthGuard;
